import { render, staticRenderFns } from "./BrandV2Icon.vue?vue&type=template&id=d47e7d5c&scoped=true"
import script from "./BrandV2Icon.vue?vue&type=script&lang=js"
export * from "./BrandV2Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47e7d5c",
  null
  
)

export default component.exports